export default __webpack_public_path__ + "static/media/npm.a859e158.svg";